import { CdnIcon, PlainA, Span, StatusBanner } from '@pcln/horizon'
import { fireFindMyTripRedirectEvent } from './ga4'

export default function FindMyTripRedirect() {
  return (
    <StatusBanner
      headingNode={<Span textStyle='body2'>Access your trip without login</Span>}
      captionNode={
        <PlainA href='/next-profile/trip-lookup' onClick={fireFindMyTripRedirectEvent}>
          <Span bold>Find Trip</Span>
        </PlainA>
      }
      iconNode={<CdnIcon iconName='search' />}
      slots={{
        baseSlot: 'mt-5 p-4',
        headingContentSlot: 'flex-row justify-between w-full',
      }}
    />
  )
}
